import React, { Component } from 'react';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import { Range } from 'rc-slider';
import './style.css';
import { URL_START } from '../../constants';
import { translate } from 'react-i18next';
import { RIEInput } from 'riek';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPen,
  faArrowRight,
  faArrowLeft
} from '@fortawesome/free-solid-svg-icons';

class Sliderbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : 50,
      left: props.left,
      right: props.right
    };
    this.handleChange = this.handleChange.bind(this);
    this.changeState = this.changeState.bind(this);
    this.save = this.save.bind(this);
  }

  handleChange(value) {
    this.setState({ value: 100 - value[0] });
  }

  componentWillReceiveProps(nextProps, nextState) {
    this.setState({
      value: 'undefined' !== typeof nextProps.value ? nextProps.value : 50
    });
  }

  changeState = newState => {
    this.setState(newState);
    const state = { ...this.state, ...newState };
    const singleAspect = {
      answer: { term: state.left, opposite: state.right }
    };
    this.props.saveAspect(singleAspect, this.props.aspectId);
  };

  save(event) {
    this.props.save(
      this.state.value,
      this.props.projectObjectUuid,
      this.props.aspectId
    );
    event.preventDefault();
    if (this.props.history.canGo(1)) {
      this.props.history.goForward();
    } else {
      this.props.history.push(this.props.findNextPath());
    }
  }

  render() {
    const { t } = this.props;

    const description = t(
      'Position the slider, where it fits best. Skip if not applicable.'
    );

    let value = this.state.value;
    if (value === -999) value = 50;

    let skip = () => {
      const nextPath = this.props.skip(
        this.props.aspectId,
        this.props.projectObjectUuid
      );
      if (this.props.history.canGo(1)) {
        this.props.history.goForward();
      } else {
        this.props.history.push(nextPath);
      }
    };

    let handleBackground;
    if (this.props.image)
      handleBackground = {
        backgroundImage: `url(${this.props.image})`,
      };
    else
      handleBackground = {
        backgroundColor: '#183450',
      };

    return (
      <div className="card-body slider-body">
        <h1 className="h6 text-muted">{this.props.completionStatus}</h1>
        <div className="object-name-container">
          <span className="object-name">{this.props.name}</span>
          <span class="status-count">{this.props.statusCount}</span>
        </div>
        <div className="text-center text-muted">{description}</div>
        <div className="row d-md-none aspect-values">
          <div className="col text-left">
            <span className="aspect-value">{value}%</span>
          </div>
          <div className="col text-right">
            <span className="aspect-value">{100 - value}%</span>
          </div>
        </div>
        <div className="row sliderbar-container">
          <div className="col-12 col-md-6 text-center mb-4 mb-md-0">
            <Range
              min={0}
              max={100}
              step={10}
              value={[100 - value]}
              onChange={this.handleChange}
              style={{ marginTop: '10px' }}
              handleStyle={[handleBackground]}
              railStyle={{
                height: '2px',
                backgroundColor: '#76828D'
              }}
            />
          </div>
          <div className="col aspect-container aspect-left order-md-first">
            <div className="aspect-editor">
              <FontAwesomeIcon className="edit-icon" icon={faPen} />
              <RIEInput
                className="aspect-text"
                value={this.state.left}
                propName="left"
                change={this.changeState}
              />
            </div>
            <span className="aspect-value d-none d-md-block">{value}%</span>
          </div>
          <div className="col d-md-none">
            {/* Just an empty div for mobile phones */}
          </div>
          <div className="col aspect-container aspect-right order-md-last">
            <div className="aspect-editor">
              <RIEInput
                className="aspect-text"
                value={this.state.right}
                propName="right"
                change={this.changeState}
              />
              <FontAwesomeIcon className="edit-icon" icon={faPen} />
            </div>
            <span className="aspect-value d-none d-md-block">
              {100 - value}%
            </span>
          </div>
        </div>
        <div
          className="actions sliderbar-actions"
          style={{ justifyContent: 'center' }}
        >
          <button
            className="btn btn-outline-primary btn-round btn-next"
            onClick={this.props.history.goBack}
            disabled={this.props.disabledBack || !this.props.history.canGo(-1)}
            style={{ width: '200px', justifyContent: 'center' }}
          >
            <FontAwesomeIcon icon={faArrowLeft} color="#183450" /> Previous
          </button>
          <button className="btn btn-link" onClick={skip}>
            Skip
          </button>
          <Link to={URL_START + '/' + this.props.projectObjectUuid + '/'}>
            <button
              className="btn btn-primary btn-round btn-next"
              onClick={this.save}
              style={{ width: '200px', justifyContent: 'center' }}
            >
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default withRouter(translate('translations')(Sliderbar));



// WEBPACK FOOTER //
// ./src/comparison-new/components/Sliderbar/index.js